import styled from 'styled-components';
import { Radio, Checkbox, Col } from 'antd';

export const BlueColor = '#2F54EB';

export const StyledRadioGroup = styled(Radio.Group)`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 16px;
	width: 100%;
`;

export const ToolsContainer = styled(Col)`
	width: 100%;
`;

export const ToolsGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 24px;
	width: 100%;

	@media (max-width: 1340px) {
		grid-template-columns: repeat(2, 1fr);
	}

	.ant-checkbox-wrapper {
		margin: 0;
		display: flex;
		align-items: center;
	}

	.ant-checkbox-wrapper span:nth-of-type(2) {
		width: 100%;
	}

	.ant-checkbox {
		display: none !important;
	}

	.ant-checkbox + span {
		padding-left: 0 !important;
		padding-right: 0 !important;
	}
`;

export const ToolContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
`;

export const LeftContent = styled.div`
	display: flex;
	align-items: center;
	flex: 1;
	margin-right: 16px;
`;

export const IconWrapper = styled.div`
	flex-shrink: 0;
	width: 24px;
	height: 24px;
	margin-right: 12px;
	display: flex;
	align-items: center;
	justify-content: center;

	svg,
	i {
		width: 100%;
		height: 100%;
		vertical-align: middle;
	}

	.ant-checkbox-wrapper-checked & {
		svg,
		i {
			color: ${BlueColor} !important;
		}
	}

	.ant-checkbox-wrapper-checked:hover & {
		svg,
		i {
			color: ${BlueColor} !important;
		}
	}

	.ant-checkbox-wrapper-disabled & {
		svg,
		i {
			color: #bfbfbf !important;
		}
	}
`;

export const NameWrapper = styled.div`
	font-size: 14px;
	font-weight: 600;
	color: #262626;
	flex-grow: 1;

	.ant-radio-button-wrapper:hover:not(.ant-radio-button-wrapper-checked):not(.ant-radio-button-wrapper-disabled) & {
		color: ${BlueColor} !important;
	}

	.ant-radio-button-wrapper-checked & {
		color: ${BlueColor} !important;
	}

	.ant-radio-button-wrapper-disabled & {
		color: #bfbfbf !important;
	}
`;

export const CustomReportsSpan = styled.span`
	background: rgb(240, 240, 240);
	color: rgb(38, 38, 38);
	padding: 10px;
	border-radius: 8px;
	min-width: 48px;
	min-height: 16px;
	text-align: center;
	font-weight: 600;

	.ant-radio-button-wrapper:hover:not(.ant-radio-button-wrapper-checked):not(.ant-radio-button-wrapper-disabled) & {
		color: ${BlueColor} !important;
		border-color: ${BlueColor} !important;
	}

	.ant-radio-button-wrapper-checked & {
		border-color: ${BlueColor} !important;
		background: #ebeefd;
		color: ${BlueColor} !important;
	}

	.ant-radio-button-wrapper-disabled & {
		background: #f5f5f5;
		color: #bfbfbf !important;
		border-color: transparent !important;
	}
`;

export const StyledCheckboxGroup = styled(Checkbox.Group)`
	width: 100%;
`;

export const StyledCheckboxContent = styled.div`
	height: auto;
	height: 56px;
	padding: 16px;
	border: 1px solid #d9d9d9;
	border-radius: 8px;
	background: #ffffff;
	transition: all 0.2s;
	width: 100%;
	line-height: 16px;
	display: flex;
	align-items: center;

	.ant-checkbox-wrapper:hover:not(.ant-checkbox-wrapper-disabled) & {
		border-color: ${BlueColor};

		${NameWrapper} {
			color: ${BlueColor} !important;
		}

		${CustomReportsSpan} {
			color: ${BlueColor} !important;
			border-color: ${BlueColor} !important;
		}

		${IconWrapper} svg,
    ${IconWrapper} i {
			color: ${BlueColor} !important;
		}
	}

	.ant-checkbox-wrapper-checked & {
		background: #ebeefd;
		border-color: #ebeefd;

		${NameWrapper} {
			color: ${BlueColor} !important;
		}

		${CustomReportsSpan} {
			border-color: ${BlueColor} !important;
			background: #ebeefd;
			color: ${BlueColor} !important;
		}

		${IconWrapper} svg,
		${IconWrapper} i {
			color: ${BlueColor} !important;
		}
	}

	.ant-checkbox-wrapper-disabled & {
		background: none;
		border-color: #f0f0f0;
		cursor: not-allowed;

		${NameWrapper} {
			color: #bfbfbf !important;
		}

		${CustomReportsSpan} {
			background: #f5f5f5;
			color: #bfbfbf !important;
			border-color: transparent !important;
		}

		${IconWrapper} svg,
		${IconWrapper} i {
			color: #bfbfbf !important;
		}
	}
`;
